import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-reset-redirect',
    templateUrl: './reset-redirect.component.html',
    styleUrls: ['./reset-redirect.component.scss'],
    standalone: false
})
export class ResetRedirectComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
    // we redirect to the outlet because some mail providers are not able to navigate with special chars in the url
    // known problem in thunderbird
  }

}
